import styles from "./ArticleRecircFooter.module.scss";

const ArticleRecircFooter = ({
  main,
  rightRail,
}: {
  main: React.ReactNode;
  rightRail?: React.ReactNode;
}) => {
  return (
    <div className={styles.root}>
      <div className={styles.main}>{main}</div>
      <div className={styles.rightRail}>{rightRail}</div>
    </div>
  );
};

export default ArticleRecircFooter;
